export default "/build/images/033-6-100x100.png?72acf8e3d6f07700dd30164e924fe33b";